// @ts-nocheck
import { CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import getBooleanProperty from "@toolkit/Framework/Common/Utilities/getBooleanProperty";

/**
 * Preserves specified line properties from order lines to corresponding cart lines during reordering.
 * Iterates through cart lines and transfers relevant properties from the matching order line,
 * enabling retention of important line-specific attributes when recreating orders.
 *
 * @param orderLines - The original order lines containing properties to be preserved, or undefined/null
 * @param cartLines - The cart lines to update with properties from order lines, or null
 *
 * @example
 * handleLinePropertiesForReorder(originalOrderLines, newCartLines);
 */
const handleLinePropertiesForReorder = (
    orderLines: OrderLineModel[] | undefined | null,
    cartLines: CartLineModel[] | null,
) => {
    if (orderLines?.length && cartLines?.length) {
        cartLines.forEach((cartLine, index) => {
            const orderLine = orderLines[index];

            if (orderLine?.properties) {
                cartLine.properties = cartLine.properties || {};

                if (getBooleanProperty(orderLine.properties.notInCatalog)) {
                    cartLine.properties.notInCatalog = orderLine.properties.notInCatalog;
                }
            }
        });
    }
};

export default handleLinePropertiesForReorder;
